export default __webpack_public_path__ + "static/media/02.f3322d9a.svg";